// extracted by mini-css-extract-plugin
export default {"svgHolder":"BGAnimation_svgHolder__kf1g1"};